 
import {
  clearScheduledMaintenance,
  deleteScheduledMaintenanceFail,
  deleteScheduledMaintenanceStarted,
  deleteScheduledMaintenanceSuccess
} from '../../../reducer/schedule-maintenance/DeleteScheduledMaintenanceReducer';
import { deleteScheduledMaintenance } from '../../actionType/schedule-maintenance/DeleteScheduledMaintenanceTypes';
import {
  ClearDeleteScheduledMaintenance,
  DeleteScheduledMaintenanceFailure,
  DeleteScheduledMaintenanceFailurePayload,
  DeleteScheduledMaintenanceRequest,
  DeleteScheduledMaintenanceStarted,
  DeleteScheduledMaintenanceSuccess,
  DeleteScheduledMaintenanceSuccessPayload
} from '../../types/schedule-maintenance/DeleteScheduledMaintenanceTypes';

export const deleteScheduledMaintenanceRequest = (
  reqObject: any
): DeleteScheduledMaintenanceRequest => ({
  type: deleteScheduledMaintenance.DELETE_SCHEDULED_MAINTENANCE_REQUEST,
  requestObject: reqObject
});

/**
 * delete metric summary started saga action
 * @returns delete metric summary action
 */
export const deleteScheduledMaintenanceStart =
  (): DeleteScheduledMaintenanceStarted => ({
    type: deleteScheduledMaintenanceStarted.type
  });

/**
 * Delete metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const deleteScheduledMaintenanceSuccessful = (
  payload: DeleteScheduledMaintenanceSuccessPayload
): DeleteScheduledMaintenanceSuccess => ({
  type: deleteScheduledMaintenanceSuccess.type,
  payload
});

/**
 * delete metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const deleteScheduledMaintenanceFailure = (
  payload: DeleteScheduledMaintenanceFailurePayload
): DeleteScheduledMaintenanceFailure => ({
  type: deleteScheduledMaintenanceFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleardeleteScheduledMaintenance =
  (): ClearDeleteScheduledMaintenance => ({
    type: clearScheduledMaintenance.type
  });
